export enum PaymentMethod {
  ITAU_BOLETO = 'itau_boleto',
  ITAU_BOLEPIX = 'itau_bolepix',
  TED = 'ted'
}

export enum StandaloneBillingStatus {
  PENDING = 'pending',
  PAID = 'paid',
  CANCELLED = 'cancelled'
}

export interface StandaloneBillingPayer {
  id: string
  type?: string
  info?: {
    name?: string
    business_name?: string
    cpf?: string
    cnpj?: string
  }
  contact_info?: {
    email?: string
    mobile_phone?: string
  }
}

export interface StandaloneBilling {
  id: string
  amount: number
  due_date: string
  description: string
  payment_method: PaymentMethod
  recipient_account_key: string
  status: StandaloneBillingStatus
  payer_person_id: string
  payer_person?: StandaloneBillingPayer
  boleto_url: string | null
  boleto_barcode: string | null
  boleto_our_number: string | null
  itau_txid: string | null
  paid_at: string | null
  paid_amount: number | null
  created_at: string
  updated_at: string
}

export interface StandaloneBillingListResponse {
  items: StandaloneBilling[]
  total: number
  page: number
  page_size: number
}
